import React from "react"
import { AuthProvider } from "../contexts/AuthContext"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Login from "./authentication/Login"
import PrivateRoute from "./authentication/PrivateRoute"
import AdminRoute from "./authentication/AdminRoute"
// import BecarioRoute from "./authentication/BecarioRoute";

// import Dashboard from "./Dashboard";
// import DashboardNew from "./DashboardNew";
// import Signup from "./authentication/Signup"
// import Admin from "./Admin";
// import Becarios from "./Becarios";
// import Pendientes from "./Pendientes";
// import Reset from "./Reset";
// import Checkin from "./Checkin";
import Update from "./Update"
import NewUser from "./NewUser"
// import Registration from "./Registration";
import UserList from "./UserList"
import RegistrationSimplified from "./RegistrationSimplified"
import Success from "./Success"
import CartItems from "./CartItems"
import CancelPage from "./CancelPage"
import AdminDashBoad from "./AdminDashboard"
function App() {
  return (
    // <CenteredContainer>
    <AuthProvider>
      <Router>
        <Switch>
          {/* Rutas abiertas a todos los usuarios */}
          <Route path='/login' component={Login} />

          {/* Rutas abiertas a usuarios registrados */}
          <PrivateRoute exact path='/' component={RegistrationSimplified} />
          <PrivateRoute exact path='/test' component={CartItems} />
          <PrivateRoute exact path='/update' component={Update} />
          <PrivateRoute exact path='/newuser' component={NewUser} />
          <PrivateRoute exact path='/success' component={Success} />
          <PrivateRoute exact path='/cancel' component={CancelPage} />

          {/* Rutas abiertas solo para usuarios con privilegios de admin */}
          <AdminRoute exact path='/admin' component={AdminDashBoad} />

          {/* <PrivateRoute exact path='/' component={Registration} /> */}

          {/* <Route path="/admin" component={Admin}/> */}
          {/* <Route path="/signup" component={Signup}/> */}

          {/* <BecarioRoute exact path="/admin" component={Admin} /> */}
          {/* <BecarioRoute exact path="/admin/pendientes" component={Pendientes} /> */}
          {/* <BecarioRoute exact path='/checkin' component={Checkin} /> */}

          {/* <AdminRoute exact path='/reset' component={Reset} /> */}
          <AdminRoute exact path='/admin/users' component={UserList} />
          {/* <AdminRoute exact path="/admin/becarios" component={Becarios} /> */}
        </Switch>
      </Router>
    </AuthProvider>
    // </CenteredContainer>
  )
}
export default App
